module.exports = __webpack_public_path__ + "static/img/cc1.1169cbfc.png";